import { render } from "./RecruitmentSubmissionDrawer.vue?vue&type=template&id=fb116e5c&scoped=true"
import script from "./RecruitmentSubmissionDrawer.vue?vue&type=script&lang=js"
export * from "./RecruitmentSubmissionDrawer.vue?vue&type=script&lang=js"

import "./RecruitmentSubmissionDrawer.css?vue&type=style&index=0&id=fb116e5c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb116e5c"]])

export default __exports__